module.exports = {
	idle: 'idle',
	loading: 'loading',
	completed: 'completed',
};
